<template>
  <div
    id="xiid"
    style="
      display: flex;
      flex-direction: column;
      height: calc(100%);
      overflow: auto;
    "
  >
    <van-skeleton :row="25" :loading="ske">
      <div class="zong" id="diao" style="height: 100%">
        <div class="div">
          <span></span>
          <img v-if="get.bgimgurl" :src="get.bgimgurl" alt />
          <img v-else src="../../assets/images/logo4.png" alt />
          <div class="img">
            <header>
              <van-icon name="arrow-left" @click="dloeBack" />
              <form
                action=""
                @submit.prevent="tiao"
                class="se"
                style="width: 100%; background: rgba(201, 201, 201, 0.3)"
              >
                <input
                  v-model="search"
                  type="search"
                  required
                  style="background: transparent; color: white"
                />
                <img
                  src="../../assets/images/shan.png"
                  alt=""
                  class="clear"
                  style="right: 0.7rem"
                  @click="clear"
                />
                <span @click="tiao">搜索</span>
              </form>
            </header>
          </div>
        </div>
        <div class="diao iao">
          <img v-lazy="get.imgurl" alt />
          <span>
            <span>
              <p>
                <span
                  style="
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden !important;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 1 !important;
                    line-clamp: 1;
                    -webkit-box-orient: vertical;
                  "
                  >{{ get.name }}</span
                >
                <span></span>
              </p>
              <p>
                <span v-if="get.follownum">{{ get.follownum }}人关注</span>
                <span v-else>0人关注</span>
                <span></span>
                <span v-if="get.goodnum">{{ get.goodnum }}件在售商品</span>
                <span v-else>0件在售商品</span>
              </p>
            </span>
            <mt-button @click="pinZhu" v-if="state == '0'">
              <van-icon name="plus" />关注
            </mt-button>
            <mt-button @click="pinZhu" v-if="state == '1'">取消关注</mt-button>
          </span>
        </div>
        <template>
          <div
            v-if="expansion == false"
            class="card-mid"
            v-html="get.descs"
          ></div>
          <div v-if="expansion == true" class="cmid" v-html="get.descs"></div>
          <span class="expen" @click="expend">
            {{ expansion ? "收起" : "展开" }}
            <van-icon :name="expansion ? 'arrow-up ' : 'arrow-down'" />
          </span>
        </template>

        <div class="as">
          <mt-navbar v-model="selected">
            <mt-tab-item
              v-for="(item, index) in zong"
              :key="index"
              :id="index"
              >{{ item.name }}</mt-tab-item
            >
          </mt-navbar>
          <mt-tab-container v-model="selected" :swipeable="true">
            <mt-tab-container-item
              v-for="(item, index) in zong"
              :key="index"
              :id="index"
              style="padding: 0px"
            >
              <div style="margin-bottom: 0.4rem" v-if="zonglist.length == 0">
                <img
                  src="../../assets/images/nodata.png"
                  alt
                  style="width: 100%; margin: 0.5rem 0px"
                />
                <span style="font-size: 0.14rem; text-align: center"
                  >目前还没有商品哦！</span
                >
              </div>
              <van-pull-refresh
                v-model="refreshing"
                @refresh="onRefresh(search)"
                loosing-text="释放刷新"
                v-else
                pulling-text="下拉刷新"
                success-text="刷新成功"
              >
                <van-list
                  v-model="loading"
                  :finished="finished"
                  finished-text="没有更多了"
                  @load="onLoads(search)"
                >
                  <ul infinite-scroll-disabled="loading">
                    <li v-for="(s, index) in zonglist" :key="index">
                      <img v-lazy="s.imgurl" alt @click="detal(s.id)" />
                      <p @click="detal(s.id)">{{ s.goods_name }}</p>
                      <p>
                        <span @click="detal(s.id)">
                          <span style="font-weight: 600">
                            ￥
                            <span>{{ s.goods_price | toint }}</span>
                          </span>
                          <span>￥{{ s.line_price | toint }}</span>
                        </span>
                        <img :src="logo" @click="goshop(s)" alt />
                      </p>
                    </li>
                  </ul>
                </van-list>
              </van-pull-refresh>
            </mt-tab-container-item>
          </mt-tab-container>
        </div>
      </div>
    </van-skeleton>
  </div>
</template>

<script>
import $ from "jquery";
import Bus from "@/bus.js";
import { Toast } from "vant";
import Util from "@/util.js";
export default {
  data() {
    return {
      logo: localStorage.getItem("mylogo"),
      expansion: false,
      ske: true,
      zonglist: [],
      finished: false,
      loading: false,
      refreshing: false,
      gou: "",
      state: "",
      dlip: "",
      search: "",
      value: "",
      form: {},
      result: "1",
      page: 1,
      rows: 10,
      count: 0,
      selected: 0,
      get: {},
      id: "",
      show: false,
      skushow: false,
      goods: [],
      userid: "",
      ganen: {},
      zong: [
        { name: "综合" },
        { name: "销量" },
        { name: "新品" },
        { name: "价格" },
      ],
    };
  },
  filters: {
    toint(value) {
      return parseInt(value);
    },
  },
  watch: {
    selected(val) {
      this.page = 1;
      if (val == 0) {
        this.zongData(this.$route.query.id, "", this.search);
      } else if (val == 1) {
        this.zongData(this.$route.query.id, "num", this.search);
      } else if (val == 2) {
        this.zongData(this.$route.query.id, "time", this.search);
      } else if (val == 3) {
        this.zongData(this.$route.query.id, "price", this.search);
      }
    },
  },
  activated() {},
  created() {
    this.allData();
  },
  methods: {
    allData() {
      this.token = localStorage.getItem("loginMobile");
      this.ganen = JSON.parse(localStorage.getItem("ganen"));
      this.userid = localStorage.getItem("user_id");
      this.zonglist = [];
      if (
        localStorage.getItem("appxiangqing") == null ||
        localStorage.getItem("appxiangqing") == undefined ||
        localStorage.getItem("appxiangqing") == "" ||
        localStorage.getItem("appxiangqing") == "null"
      ) {
        var arr = {
          id: this.$route.query.id,
          dlip: this.$route.params.dlip,
          pin: this.$route.params.pin,
          se: this.$route.params.se,
          con: this.$route.params.con,
          lie: this.$route.params.lie,
          hot: this.$route.params.hot,
          nav: this.$route.params.nav,
        };
        localStorage.setItem("appxiangqing", JSON.stringify(arr));
        this.getDiao(this.$route.query.id);
        this.getpin(this.$route.query.id);
        if (this.selected == 0) {
          this.zongData(this.$route.query.id, "", this.search);
        } else if (this.selected == 1) {
          this.zongData(this.$route.query.id, "num", this.search);
        } else if (this.selected == 2) {
          this.zongData(this.$route.query.id, "time", this.search);
        } else if (this.selected == 3) {
          this.zongData(this.$route.query.id, "price", this.search);
        }
      } else {
        var arr = JSON.parse(localStorage.getItem("appxiangqing"));
        if (arr.id == this.$route.query.id) {
          var arr = JSON.parse(localStorage.getItem("appxiangqing"));
          this.page = 1;
          this.getDiao(arr.id);
          this.getpin(arr.id);
          if (this.selected == 0) {
            this.zongData(arr.id, "", this.search);
          } else if (this.selected == 1) {
            this.zongData(arr.id, "num", this.search);
          } else if (this.selected == 2) {
            this.zongData(arr.id, "time", this.search);
          } else if (this.selected == 3) {
            this.zongData(arr.id, "price", this.search);
          }
        } else {
          var arr = {
            id: this.$route.query.id,
            dlip: this.$route.params.dlip,
            pin: this.$route.params.pin,
            se: this.$route.params.se,
            con: this.$route.params.con,
            lie: this.$route.params.lie,
            hot: this.$route.params.hot,
            nav: this.$route.params.nav,
          };
          localStorage.setItem("appxiangqing", JSON.stringify(arr));
          var arr = JSON.parse(localStorage.getItem("appxiangqing"));
          this.page = 1;
          this.getDiao(arr.id);
          this.getpin(arr.id);
          if (this.selected == 0) {
            this.zongData(arr.id, "", this.search);
          } else if (this.selected == 1) {
            this.zongData(arr.id, "num", this.search);
          } else if (this.selected == 2) {
            this.zongData(arr.id, "time", this.search);
          } else if (this.selected == 3) {
            this.zongData(arr.id, "price", this.search);
          }
        }
      }
    },
    clear() {
      this.search = "";
    },
    setScrollTop(e) {
      localStorage.setItem("scrollTop", e.target.scrollTop);
    },
    async goshop(e) {
      this.gologin();
      var y = await Util.checklimit(e.limits, e.id, 1);
      if (y == false) {
        Toast({
          message: "当前商品限购" + e.limits + "件",
          icon: "fail",
          duration: 3000,
        });
        return;
      } else {
        var str = {
          goods_attr: e.spec_value,
          token: localStorage.getItem("loginMobile"),
          goods_id: e.id,
          num: 1,
          goods_spec_id: e.goods_specid,
          imgurl: e.imgurl,
        };
        this.$api.post(this.$api.base, "/wxapi/shopcar/add", str, async (r) => {
          if (r.data.status == 200) {
            setTimeout(() => {
              Toast({ message: "添加成功", icon: "success", duration: 3000 });
            }, 100);
            var sum = await Util.buycount();
            Bus.$emit("numindex", sum);
          } else if (r.data.status == 400) {
            setTimeout(() => {
              Toast({ message: "添加失败", icon: "fail", duration: 3000 });
            }, 100);
          } else {
            this.isLogin(r);
          }
        });
      }
    },
    expend() {
      if (this.expansion == false) {
        this.expansion = true;
      } else {
        this.expansion = false;
      }
    },
    getpin(e) {
      this.$api.post(this.$api.base, "/wxapi/category/info", { id: e }, (r) => {
        if (r.data.status == 200) {
          this.ske = false;
          this.get = r.data.data;
        }
      });
    },
    detal(e) {
      var id = JSON.parse(localStorage.getItem("appxiangqing"));
      this.$router.push({
        name: "Ta",
        query: { id: e },
        params: {
          nav: id.nav,
          hot: id.hot,
          dlip: id.dlip,
          lie: id.lie,
          se: id.se,
          pin: id.id,
        },
      });
    },
    dloeBack() {
      this.$router.go(-1);
    },
    tiao() {
      this.page = 1;
      var str = this.$route.query.id;
      if (this.selected == 0) {
        this.zongData(str, "", this.search);
      } else if (this.selected == 1) {
        this.zongData(str, "num", this.search);
      } else if (this.selected == 2) {
        this.zongData(str, "time", this.search);
      } else if (this.selected == 3) {
        this.zongData(str, "price", this.search);
      }
    },
    zongData(e, v, m) {
      var parses = {
        page: this.page,
        rows: this.rows,
        brandid: e,
        wxapp_id: localStorage.getItem("mid"),
        order: v,
        goods_name: m,
      };
      this.$api.post(this.$api.base, "/wxapi/goods/list", parses, (r) => {
        if (r.data.status == 200) {
          this.ske = false;
          this.loading = false;
          this.total = r.data.count;
          if (r.data.data.length === 0) {
            this.finished = true;
            this.zonglist = [];
            return;
          }
          if (this.page == 1) {
            this.zonglist = r.data.data;
          } else {
            this.zonglist = this.zonglist.concat(r.data.data);
          }
          if (this.zonglist.length < this.total) {
            this.finished = false;
            this.page++;
          } else {
            this.finished = true;
          }
        }
      });
    },
    sku() {
      this.skushow = false;
    },
    onLoads(m) {
      var str = this.$route.query.id;
      if (this.selected == 0) {
        this.zongData(str, "", m);
      } else if (this.selected == 1) {
        this.zongData(str, "num", m);
      } else if (this.selected == 2) {
        this.zongData(str, "time", m);
      } else if (this.selected == 3) {
        this.zongData(str, "price", m);
      }
    },
    onRefresh(m) {
      var str = this.$route.query.id;
      this.refreshing = false;
      this.page = 1;
      this.zonglist = [];
      if (this.selected == 0) {
        this.zongData(str, "", m);
      } else if (this.selected == 1) {
        this.zongData(str, "num", m);
      } else if (this.selected == 2) {
        this.zongData(str, "time", m);
      } else if (this.selected == 3) {
        this.zongData(str, "price", m);
      }
    },
    getDiao(e) {
      var token = localStorage.getItem("loginMobile");
      if (
        token != undefined &&
        token != "" &&
        token != null &&
        token != "null" &&
        token != "undefined"
      ) {
        this.$api.post(
          this.$api.base,
          "/wxapi/follow/cate/check",
          { token: token, cateid: e },
          (r) => {
            if (r.data.status == 400) {
              this.state = "0";
            } else if (r.data.status == 200) {
              this.state = "1";
            } else {
              this.isLogin(r);
            }
          }
        );
      } else {
        this.state = "0";
        return;
      }
    },
    pinZhu() {
      var str = JSON.parse(localStorage.getItem("appxiangqing"));
      this.gologin();
      if (this.state == "0") {
        this.$api.post(
          this.$api.base,
          "/wxapi/follow/cate",
          { token: this.token, cateid: str.id },
          (r) => {
            if (r.data.status == 200) {
              setTimeout(() => {
                Toast({ message: "关注成功", icon: "success", duration: 3000 });
              }, 100);
              this.state = "1";
            }
            if (r.data.status == 400) {
              setTimeout(() => {
                Toast({ message: "关注失败", icon: "fail", duration: 3000 });
              }, 100);
            } else {
              this.isLogin(r);
            }
          }
        );
      } else if (this.state == "1") {
        this.guZhu();
      }
    },
    guZhu() {
      var str = JSON.parse(localStorage.getItem("appxiangqing"));
      this.$api.post(
        this.$api.base,
        "/wxapi/nofollow/cate",
        { token: this.token, id: str.id },
        (r) => {
          if (r.data.status == 200) {
            this.state = "0";
            setTimeout(() => {
              Toast({ message: "已取消成功", icon: "success", duration: 3000 });
            }, 100);
          } else if (r.data.status == 400) {
            setTimeout(() => {
              Toast({ message: "取消失败", icon: "fail", duration: 3000 });
            }, 100);
          } else {
            this.isLogin(r);
          }
        }
      );
    },

    isLogin(res) {
      if (res.data.status == 401) {
        if (
          localStorage.getItem("mid") != null &&
          localStorage.getItem("mid") != undefined &&
          localStorage.getItem("mid") != "null"
        ) {
          window.localStorage.setItem("mid", "");
          window.localStorage.setItem("user_id", null);
        }
        window.location.href = "https://www.nigilichan-go.com/wxlogin";
        return false;
      }
    },
  },
};
</script>
<style  lang="scss" scoped>
@import "../../scss/home";
.cmid {
  line-height: 0.2rem;
  font-size: 0.11rem;
  padding: 0px 0.1rem;
  color: rgb(28, 28, 28);
}
.card-mid {
  font-size: 0.11rem;
  color: rgb(28, 28, 28);
  padding: 0px 0.1rem;
  line-height: 0.2rem;
  overflow: hidden !important;
  -webkit-line-clamp: 3;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  z-index: 10;
  height: 0.6rem;
}
.card-mid p:nth-of-type(2) {
  height: 0rem;
  overflow: hidden;
}
.expen {
  font-size: 0.09rem;
  text-align: right;
  padding: 0.05rem 0px;
  padding-right: 0.2rem;
}
</style>
